export function goToStartSection(id: string, mode?: "smooth" | "auto") {
    const section = document.getElementById(id);
    if (!section) return;
    window.scrollTo({
        top: section.offsetTop - 120,
        behavior: mode || "smooth"
    })
}